import { render, staticRenderFns } from "./FormPagePosition.vue?vue&type=template&id=2ee8a2da&"
import script from "./FormPagePosition.vue?vue&type=script&lang=js&"
export * from "./FormPagePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports